const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://api-staging.grifin-app.com","environment":"staging"};